<template>
  <section
    v-if="showMentions"
    ref="list"
    class="suggestion-list"
    name="mentions"
    aria-label="mentions"
  >
    <template v-if="items.length">
      <div
        v-for="(option, index) in items"
        :key="index"
        class="suggestion-list__item"
        :index="index"
        :class="{ 'is-selected': selectedIndex === index }"
        @click="selectItem(index)"
      >
        <div>
          <slot v-bind="option">{{ option }}</slot>
        </div>
      </div>
    </template>
    <div v-else class="suggestion-list__item is-empty">
      {{ emptyMessage }}
    </div>
  </section>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    command: {
      type: Function,
      default: () => undefined
    },
    query: {
      type: String,
      default: ''
    },
    handleSelectItem: {
      type: Function,
      default: null
    },
    emptyMessage: {
      type: String,
      default: 'Não encontramos staff com esse nome'
    }
  },
  data() {
    return {
      selectedIndex: 0
    }
  },
  computed: {
    showMentions() {
      return this.query || this.items.length
    }
  },
  watch: {
    items() {
      this.selectedIndex = 0
    }
  },
  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }

      if (event.key === 'Enter') {
        this.enterHandler()
        return true
      }

      return false
    },
    upHandler() {
      const index = this.selectedIndex - 1
      this.selectedIndex = index < 0 ? this.items.length - 1 : index
      this.updateSelectPosition()
    },
    downHandler() {
      const index = this.selectedIndex + 1
      this.selectedIndex = index === this.items.length ? 0 : index
      this.updateSelectPosition()
    },
    updateSelectPosition() {
      if (!this.$refs.list) return
      this.$refs.list
        .querySelector(`[index="${this.selectedIndex}"]`)
        ?.scrollIntoView(true)
    },
    enterHandler() {
      this.selectItem(this.selectedIndex)
    },

    selectItem(index) {
      const item = this.items[index]

      if (item) {
        if (!this.handleSelectItem) {
          this.command({
            id: item.id,
            label: item.fullName
          })

          return
        }
        this.handleSelectItem(item)
      }
    }
  }
}
</script>
